<div class="text-center">
    <img class="img-responsive" src="assets/images/Logo_Autostrade-new.png" alt="welcome">
</div>
<lib-dashboard [dashboardSettings]="settings"></lib-dashboard>